import * as React from "react";
import bar1 from "../../icons/bar1.png";
import bar2 from "../../icons/bar2.png";
import moment from "moment";
import "./profileTop.css";
import "../../style/App.css";
import translate from "../../translations/i18n";
import { calculateSmokeless } from "../../functions/calculateSmokeless";

export interface Props {
  start_date: number;
}

class UserBar extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const daysString = calculateSmokeless(this.props.start_date);

    if (this.props.start_date) {
      return (
        <div>
          <div className="BAR_POS">
            <div className="BARCONTAINER">
              <div className="BAR1">
                <img src={bar1} />
              </div>
              <div className="BAR2">
                <img src={bar2} />
              </div>
              {daysBar(this.props.start_date)}
            </div>
          </div>
          <div className="DAYS2">
            <div className="TITLE_3">{daysString}</div>
          </div>
        </div>
      );
    } else return null;
  }
}

export default UserBar;

function daysBar(start) {
  const days = daysInProgram(start);
  const days_width: string = ((days / 90) * 296).toString() + "px";
  const bar_width = {
    width: days_width
  };
  if (days < 90) {
    return <div className="BAR3" style={bar_width} />;
  } else {
    return <div className="BAR3_FULL" />;
  }
}

function daysInProgram(start): number {
  const start_date = moment(start).startOf("day");
  const today = moment(new Date()).startOf("day");
  const duration = today.diff(start_date, "day");
  return duration;
}



// WEBPACK FOOTER //
// ./src/components/profileTop/userBar.tsx